import React from 'react'
import { PuckProviders } from 'breaktime-theme/src/puck/PuckProviders'
import { config as puckConfig } from './src/lib/puck/config'

export const wrapRootElement = ({ element }) => (
  <PuckProviders config={puckConfig}>{element}</PuckProviders>
)
